import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Star, Package, Factory } from 'lucide-react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge">
            <Star size={16} fill="currentColor" />
            <span>Excellence & Qualité</span>
          </div>
          <h1 className="hero-title">
            Phoenix Negoce
            <span className="hero-subtitle">Votre partenaire négoce de confiance</span>
          </h1>
          <p className="hero-description">
            Phoenix Negoce est spécialisé dans le négoce de produits issus de fabricants et de marques reconnues.
            Nous travaillons en direct usine afin d'offrir des solutions adaptées : lots, volumes, déstockage et commandes spécifiques.
          </p>
          <p className="hero-description-secondary">
            Le catalogue en ligne permet de découvrir les produits proposés ; certains sont disponibles immédiatement en stock, tandis que d'autres sont proposés sur commande, directement en fabrication.
          </p>
          <div className="hero-actions">
            <Link to="/catalogue" className="btn-primary">
              Découvrir le catalogue
              <ArrowRight size={20} />
            </Link>
            <Link to="/contact" className="btn-secondary">
              Nous contacter
            </Link>
          </div>
        </div>
      </section>

      {/* Category Buttons Section */}
      <section className="categories-section section-padding">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-secondary">Découvrez Nos Produits</h2>
            <p className="section-description">
              Choisissez la catégorie qui vous intéresse
            </p>
          </div>

          <div className="category-buttons">
            <Link to="/catalogue" className="category-card">
              <div className="category-icon">
                <Package size={48} />
              </div>
              <h3 className="category-title">En Stock</h3>
              <p className="category-description">
                Produits disponibles immédiatement, prêts à être expédiés
              </p>
              <span className="category-link">
                Voir les produits
                <ArrowRight size={18} />
              </span>
            </Link>

            <Link to="/production" className="category-card">
              <div className="category-icon production-icon">
                <Factory size={48} />
              </div>
              <h3 className="category-title">Production</h3>
              <p className="category-description">
                Commandes spéciales directement en fabrication
              </p>
              <span className="category-link">
                Voir les produits
                <ArrowRight size={18} />
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="heading-secondary">Prêt à découvrir nos produits ?</h2>
          <p className="cta-description">
            Contactez-nous dès aujourd'hui pour obtenir un devis personnalisé
          </p>
          <Link to="/contact" className="btn-primary btn-large">
            Nous contacter maintenant
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
